// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file useIcon.ts
 * @input Semantic icon name
 * @output Exports useIcon hook for theme-aware icon lookup
 * @position Client hook for components that render registry icons directly
 */
import { useThemeName } from "../theme/useTheme.js";
import { getIcon } from "./globalIconRegistry.js";

/**
 * Resolve a semantic icon name from the nearest Theme, falling back through
 * root theme registration, global icon overrides, and built-in defaults.
 */
export function useIcon(name) {
  const themeName = useThemeName();
  return getIcon(name, themeName);
}